import React from 'react'

const Logo = ({ collapsed = false }) => {
  if (collapsed) {
    return <img src='images/njsig-logo-1.png' style={{ width: 170 }} alt='' />
  } else {
    return <img src='images/njsig-logo-1.png' style={{ width: 170 }} alt='' />
  }
}

export default Logo
